import { sendLogRecorders, fetchLogRecorders } from "../../helpers/fetching";

export default {
  state: {
    data: {},
    loading: false,
    error: null,
    responseLogRecorders: null,
    loadingLogs: false
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setUuidTypesByCompany(state, data) {
      state.data = data;
    },
    setUuidTypesByCompanyLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setUuidTypeByCompanyResponse(state, data) {
      state.response = data;
    },
    setResetUuidTypesByCompany(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
    setResponseLogRecorders(state, data) {
      state.responseLogRecorders = data;
    },
    setLogRecorders(state, data) {
      state.logRecorders = data;
    },
    setLoadingLogs(state, data){
      state.loadingLogs = data;
    }
  },
  actions: {
    
    saveLog({ commit, state }, data) {
      if(state.loadingLogs) return;
      commit("setLoadingLogs", true);
      return new Promise(r=>{
          let result = sendLogRecorders(data, r);
          commit("setResponseLogRecorders", result);
          commit("setLoadingLogs", false);
      })
    },

    fetchRecorder({ commit, state }, data) {
      if(state.loadingLogs) return;
      commit("setLoadingLogs", true);
      return new Promise(r=>{
          let result = fetchLogRecorders(data, r);
          commit("setLogRecorders", result);
          commit("setLoadingLogs", false);
      })
    },
  },
};


